import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Form } from "antd";

import InputItem from "../../generic/inputItem";
import LoadError from "../../generic/loadError";
import LoadSkeleton from "../../generic/loadSkeleton";
import TooltipButton from "../../generic/tooltipButton";
import { getEntity } from "../../../../modules/crudOperations";

const ClientUserForm = ({ form, client, component: Component }) => {
  const formItemLayout = {
    labelCol: { span: client ? 4 : 3 },
    wrapperCol: { span: 8 },
    colon: false,
  };
  const { getFieldDecorator } = form;

  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  const handleSubmit = useCallback(
    (e) => {
      e && e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          getEntity(
            `${client ? "client" : "user"}/${values.search}`,
            client ? "users" : "clients",
            setLoading,
            setData
          );
        }
      });
    },
    [form, client]
  );

  return (
    <Row>
      <Col span={24}>
        <Form {...formItemLayout}>
          <InputItem
            required
            allowClear
            fieldName="search"
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
            label={
              client ? (
                <FormattedMessage
                  id="clientUser.accountOrName"
                  defaultMessage="z-account/název klienta"
                />
              ) : (
                <FormattedMessage
                  id="clientUser.username"
                  defaultMessage="uživatelské jméno"
                />
              )
            }
          />
          <TooltipButton
            onClick={handleSubmit}
            text={
              <FormattedMessage
                id="messages.search"
                defaultMessage="Vyhledat"
              />
            }
          />
        </Form>
        {loading ? (
          <LoadSkeleton />
        ) : data === "e" ? (
          <LoadError onClick={handleSubmit} />
        ) : data ? (
          <Component data={data} />
        ) : (
          <></>
        )}
      </Col>
    </Row>
  );
};

export default Form.create()(ClientUserForm);
